import Vue, { KeepAlive } from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/Index.vue';
import NotFound from '../views/404.vue';

Vue.use(VueRouter);

const routes = [
  {
    name: 'Index',
    path: '/',
    component: Index
  },
  {
    name: 'Codes',
    path: '/Codes',
    component: () => import('../views/Codes.vue')
  },
  {
    name: 'Programs',
    path: '/Programs',
    component: () => import('../views/Programs.vue')
  },
  {
    name: 'Papers',
    path: '/Papers',
    component: () => import('../views/Papers.vue')
  },
  {
    name: 'Magnetic',
    path: '/Dataset/Magnetic',
    component: () => import('../views/Dataset_Magnetic.vue'),
  },
  {
    name: 'Magnetic_Details',
    path: '/Dataset/Magnetic/:bnsNotation',
    component: () => import('../views/Dataset_Magnetic_Details.vue')
  },
  {
    name: 'Spin_Collinear',
    path: '/Dataset/Spin/Collinear',
    component: () => import('../views/Dataset_Spin_Collinear.vue')
  },
  {
    name: 'Spin_Collinear_Details',
    path: '/Dataset/Spin/Collinear/:position',
    component: () => import('../views/Dataset_Spin_Collinear_Details.vue')
  },
  {
    name: 'Login',
    path: '/Login',
    component: () => import('../views/Admin/Login.vue')
  },
  {
    name: 'Manage_Home',
    path: '/Manage/Home',
    component: () => import('../views/Admin/Home.vue')
  },
  {
    name: 'Manage_Data',
    path: '/Manage/Data',
    component: () => import('../views/Admin/Data.vue')
  },
  {
    name: 'Manage_Codes',
    path: '/Manage/Codes',
    component: () => import('../views/Admin/Codes.vue')
  },
  {
    name: 'Manage_Programs',
    path: '/Manage/Programs',
    component: () => import('../views/Admin/Programs.vue')
  },
  {
    name: 'Manage_Papers',
    path: '/Manage/Papers',
    component: () => import('../views/Admin/Papers.vue')
  },
  {
    name: 'Manage_SecretKey',
    path: '/Manage/SecretKey',
    component: () => import('../views/Admin/SecretKey.vue')
  },
  {
    name: 'NotFound',
    path: '*',
    component: NotFound
  }
];

const router = new VueRouter({
  mode: 'history',
  base: "",
  routes
});

export default router;